export default __webpack_public_path__ + "static/media/arrow_top.d6a1e097.svg";